import { render, staticRenderFns } from "./TableAndHeader.vue?vue&type=template&id=bf9c52aa&scoped=true&"
import script from "./TableAndHeader.vue?vue&type=script&lang=js&"
export * from "./TableAndHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9c52aa",
  null
  
)

export default component.exports